export const en = {
    'request-error': 'An error has occurred. Please try again.'
};
